var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanhangwenzi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0859 4.5332C10.7305 4.13086 11.4746 3.92969 12.3184 3.92969C13.8809 3.92969 14.6621 4.75 14.6621 6.39062V10.5625H13.5254V9.56055H13.4961C13.0469 10.3301 12.3848 10.7148 11.5098 10.7148C10.8809 10.7148 10.3809 10.5449 10.0098 10.2051C9.63867 9.86523 9.45312 9.40625 9.45312 8.82812C9.45312 7.61719 10.1699 6.91211 11.6035 6.71289L13.5254 6.44336C13.5254 5.38477 13.0879 4.85547 12.2129 4.85547C11.4355 4.85547 10.7266 5.11719 10.0859 5.64062V4.5332ZM12.0078 7.51562C11.4766 7.58594 11.1094 7.71875 10.9062 7.91406C10.707 8.10938 10.6074 8.38281 10.6074 8.73438C10.6074 9.04297 10.7168 9.29492 10.9355 9.49023C11.1543 9.68555 11.4434 9.7832 11.8027 9.7832C12.3027 9.7832 12.7148 9.60742 13.0391 9.25586C13.3633 8.9043 13.5254 8.46289 13.5254 7.93164V7.31055L12.0078 7.51562Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76172 10.5625H7.4668L6.54102 8.07812H2.76172L1.88867 10.5625H0.59375L4.05078 1.48633H5.30469L8.76172 10.5625ZM6.17773 7.05273L4.80664 3.2793C4.76367 3.1582 4.7168 2.94727 4.66602 2.64648H4.63672C4.59375 2.91992 4.54492 3.13086 4.49023 3.2793L3.13086 7.05273H6.17773Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 13.25H15.5",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanhangwenzi);
export default __webpack_public_path__ + "static/media/danhangwenzi.509ae1925968fe03e1d51e892cd8a31a.svg";
export { ForwardRef as ReactComponent };